import { render } from "./VDrink.vue?vue&type=template&id=3448e6b9"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/VDrink.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3448e6b9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3448e6b9', __exports__)) {
    api.reload('3448e6b9', __exports__)
  }
  
  module.hot.accept("./VDrink.vue?vue&type=template&id=3448e6b9", () => {
    api.rerender('3448e6b9', render)
  })

}


export default __exports__